export default function setLanguageContent(data, type, language = 'en') {
  if ((!data || typeof data !== 'object') || !type || data && data[type] === 'null') return '';
  if (data && data[type] && data[type][language]) return data[type][language];
  if (data && data[type] && typeof data[type] === 'string') return data[type];
  return data && data[type] && data[type].language && data[type][language] ? data[type][language] : '';
}